<!-- TEMPLATE -->
<template>
  <div :class="deanHeaderProfile" @click="itemClicked">
    <div class="dean-header-profile-content">
      <img class="dean-header-profile-content-img" :src="img" />
      <dean-icon
        class="dean-header-profile-content-icon"
        :glyph="settings"
        height="20"
        width="20"
      ></dean-icon>
      <p><slot></slot></p>
    </div>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
// VUE
import Vue from 'vue';
import { Component, Prop, Emit } from 'vue-property-decorator';

// SVG
import settings from '../svg/feather-icons/settings.svg';
import profile from '../svg/feather-icons/user-active.svg';

// COMPONENTS
import deanIcon from './deanIcon.vue';

@Component({
  components: {
    deanIcon
  }
})
export default class deanHeaderProfile extends Vue {
  // PROPS
  @Prop() state!: string;
  @Prop() img!: string;
  @Prop() src!: string;
  @Prop({ default: false }) active!: boolean;
  @Prop({ default: false }) mobile!: boolean;

  settings: object = settings;
  profile: object = profile;

  // EMIT
  @Emit('dean-header-item-click')
  itemClicked(data: string) {
    console.log(data);
  }

  // COMPUTED
  get deanHeaderProfile() {
    let value = 'dean-header-profile';
    if (this.active) value += ` dean-header-profile-active`;
    if (this.mobile) value += ` dean-header-profile-mobile small-4 columns`;
    if (this.state) {
      value += ` dean-header-profile-${this.state}`;
    }
    return value;
  }

  get deanHeaderProfileImg() {
    let value = `../assets/profile.png`;
    if (this.src) {
      value = `${this.src}`;
    }
    return value;
  }
}
</script>

<!-- STYLE -->
<style lang="scss" scoped>
// IMPORT
@import '../scss/vars';

// DEAN HEADER PROFILE
.dean-header-profile {
  display: inline-block;
  min-width: 80px;
  height: 100%;
  cursor: pointer;
  border-bottom: 4px solid white;
  @include transition(all ease 0.8s);

  .dean-header-profile-content {
    display: block;
    min-width: 80px;
    padding: 0;
    margin: auto;
    @include vertical-align(55%);

    .dean-header-profile-content-img {
      display: block;
      height: 30px;
      width: 30px;
      margin: auto;
      @include border-radius(100px);
      border: 1px solid var(--color-light, $color-light);
    }

    .dean-header-profile-content-icon {
      display: block;
      position: absolute;
      top: 0;
      right: 10px;
      text-align: center;
      fill: var(--color-dark-shade-4, $color-dark-shade-4);
      @include transition(all ease 0.8s);
    }

    p {
      padding: 5px;
      margin: 0;
      text-align: center;
      text-transform: lowercase;
      min-width: 100%;
    }

    &:hover {
      color: var(--color-primary, $color-primary);
      .dean-header-profile-content-img {
        border: 1px solid var(--color-primary, $color-primary);
      }
      .dean-header-profile-content-icon {
        fill: var(--color-primary, $color-primary);
      }
    }
  }
  &:hover {
    border-bottom: 4px solid var(--color-primary, $color-primary);
  }
}

.dean-header-profile-active {
  border-bottom: 4px solid var(--color-primary, $color-primary);

  .dean-header-profile-content {
    color: var(--color-primary, $color-primary);
    .dean-header-profile-content-img {
      border: 1px solid var(--color-primary, $color-primary);
    }
    .dean-header-profile-content-icon {
      fill: var(--color-primary, $color-primary);
    }
  }
}
.dean-header-profile-mobile {
  display: block;
  padding: 10px;
  border: none;
  &:hover {
    border-bottom: none;
  }
  .dean-header-profile-content {
    @include vertical-align(0);
    width: 80px;
  }
  .dean-header-profile-active {
    border: none;
  }
}
</style>
